import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJinjaComponent } from './simple-icons-jinja.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJinjaComponent ],
    exports:      [ SimpleIconsJinjaComponent ],
    bootstrap:    []
})
export class SimpleIconsJinjaModule {}
